import { LmsTrainingsTableFields } from './enums'

export const lmsTrainingTableHeaderTitles: Record<LmsTrainingsTableFields, string> = {
  [LmsTrainingsTableFields.id]: 'ID',
  [LmsTrainingsTableFields.externalId]: 'External ID',
  [LmsTrainingsTableFields.title]: 'Title',
  [LmsTrainingsTableFields.description]: 'Description',
  [LmsTrainingsTableFields.url]: 'Link',
  [LmsTrainingsTableFields.createdAt]: 'Date created',
  // The actions column is buttons only; a header would just add noise.
  [LmsTrainingsTableFields.actions]: '',
}

// A global catalog of a handful of rows, so this stops at 100. The customers list carries
// 500/1000 only because of an explicit product request recorded alongside it.
export const lmsTrainingPageSizeOptions = [25, 50, 100]

export const LMS_COURSES_GRID_COLUMNS_STORAGE_KEY = 'admin.lmsCourses.gridColumns'
